'use client';

import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import type { ITooltip, TooltipRefProps } from 'react-tooltip';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const Tooltip = forwardRef<TooltipRefProps, PropsWithChildren<ITooltip>>(
  ({ children, ...rest }, forwardedRef) => {
    return (
      <ReactTooltip
        closeEvents={{ click: true }}
        globalCloseEvents={{
          escape: true,
          scroll: true,
          clickOutsideAnchor: true,
        }}
        {...rest}
        ref={forwardedRef}
      >
        {children}
      </ReactTooltip>
    );
  }
);

Tooltip.displayName = 'Tooltip';
